import type { Money, ProductID, ProductVariantID } from '@ifixit/helpers';
import { ProductOemPartnership } from './models/cart';
import { CartWarning, type DisplayableError } from '@ifixit/shopify-storefront-client';

export enum CartMutationType {
   AddToCart = 'add-to-cart',
   UpdateLineItemQuantity = 'update-line-item-quantity',
   RemoveLineItem = 'remove-line-item',
}

export interface Cart {
   hasItemsInCart: boolean;
   isEmpty: boolean;
   lineItems: CartLineItem[];
   totals: {
      discount: Money<number> | null;
      itemsCount: number;
      price: Money;
      compareAtPrice?: Money | null | undefined;
   };
   checkoutUrl?: string;
   shopifyCartId?: string;
   userErrors?: DisplayableError[];
   validationErrors?: string[];
   warnings?: CartWarning[];
}

export interface CartLineItem {
   itemcode: string;
   variantTitle: string;
   shopifyVariantId: ProductVariantID;
   shopifyProductId: ProductID;
   name: string;
   internalDisplayName?: string;
   imageSrc?: string | null;
   quantity: number;
   quantityAvailable?: number;
   price: Money;
   compareAtPrice?: Money | null;
   categories?: string[] | null;
   url: string;
   shopifyLineId?: string;
   fulfiller?: string | null;
   oemPartnership: ProductOemPartnership | null;
   isBackordered: boolean;
   isPreorder: boolean;
   /** Whether the item requires shipping (false for digital products like subscriptions). */
   requiresShipping: boolean;
   /** Shopify selling plan ID for subscription items (full GID). */
   sellingPlanId?: string;
   /**
    * How often the selling plan bills. The selling plan ID identifies the plan
    * but says nothing about its cadence, and analytics needs to tell a monthly
    * subscriber from an annual one. One field, so a count without an interval
    * cannot be written.
    */
   billingPolicy?: BillingPolicy;
}

/** Billing cadence of a Shopify selling plan, as its billing policy reports it. */
export type BillingInterval = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';

export interface BillingPolicy {
   interval: BillingInterval;
   /** How many `interval`s between charges. Usually 1. */
   intervalCount: number;
}
